import axios from 'axios';

const api = axios.create({ withCredentials: true });

api.interceptors.response.use(
    res => res,
    async err => {
        if (err.response?.status === 401 && err.response?.data?.code === 'ACS-9') {
            try {
                await axios.post('/api/session/refresh', {}, { withCredentials: true });
                return api(err.config);
            } catch {
                localStorage.setItem('@logged', '');
                window.location.href = '/';
            }
        }
        return Promise.reject(err);
    }
);

export default api;
